const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Mayank Anand</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Editor in Chief, UPES-CSI</li>
    <li>
        Leading editorial and content strategy.
    </li>
    <li>
        Ensuring quality and consistency in communications.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
